import { Pipe, PipeTransform } from '@angular/core';
import { UmbracoImage } from '@models/umbraco.model';
import { VideoPlayerService } from '@features/video-player/video-player.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'getVideoThumbnail',
    standalone: true
})
export class GetVideoThumbnailPipe implements PipeTransform {
    constructor(private videoPlayerService: VideoPlayerService) {}

    transform(image?: UmbracoImage, videoId?: string): Observable<string> {
        if (image && !videoId) {
            return of(image?.src);
        }

        if (image && videoId) {
            return of(image?.src || '');
        }

        return this.videoPlayerService
            .getVimeoVideoDetails(videoId)
            .pipe(map(video => video?.thumbnail_url ?? image?.src ?? ''));
    }
}
